import { BuilderConfig } from '../../types/Builder';
import BusinessHubHowApWorks, { BusinessHubHowApWorksProps } from './business-hub-how-ap-works';

export const BusinessHubHowApWorksBuilderConfig = {
    name: 'Business Hub How Afterpay Works',
    inputs: [
        {
            name: 'title',
            type: 'string',
            defaultValue: '',
        },
        {
            name: 'steps',
            type: 'list',
            subFields: [
                // {
                //     name: 'name',
                //     type: 'string',
                //     required: true,
                // },
                {
                    name: 'description',
                    type: 'richText',
                },
                {
                    name: 'descriptionMaxWidth',
                    type: 'number',
                },
                {
                    name: 'icon',
                    type: 'file',
                    required: true,
                },
                {
                    name: 'illustration',
                    type: 'file',
                    required: true,
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubHowApWorksProps> = {
    component: BusinessHubHowApWorks,
    config: BusinessHubHowApWorksBuilderConfig,
};

export default builderConfig;
